import R from "ramda";

export const OAUTH_TOKEN = "local-storage/keys/oauth/token";
export const OAUTH_STATE = "local-storage/keys/oauth/state";
export const VISIBLE_DOCUMENTS_COLUMNS = "local-storage/keys/documents/visible-documents-columns";
export const DOCUMENTS_SORTING_ORDER = "local-storage/keys/documents/documents-sorting-order";
export const SELECTED_ACCOUNT_SLUG = "local-storage/keys/app/selected-account-slug";
export const SELECTED_ACCOUNT_ID = "local-storage/keys/app/selected-account-id";

const isLocalStorageSupported = () => {
  try {
    const testKey = "test";
    const storage = window.localStorage;
    storage.setItem(testKey, "true");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

const cookie = {
  getItem: (key) => {
    const data = parseCookieData();
    return data[key];
  },
  setItem: (key, value) => {
    const data = parseCookieData();
    data[key] = value;
    const stringData = JSON.stringify(data);
    document.cookie = `localStorage=${stringData}`;
  },
  removeItem: (key) => {
    const data = parseCookieData();
    const newData = R.dissoc(key, data);
    const stringData = JSON.stringify(newData);
    document.cookie = `localStorage=${stringData}`;
  },
  isSet: (key) => {
    const data = parseCookieData();
    const value = R.propOr(null, key, data);
    return value !== null;
  }
};

const parseCookieData = () => {
  const cookieName = "localStorage";
  const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
  if (match) {
    return JSON.parse(match[1]);
  }
  return {};
};

export const storage = {
  set: (key, value) => {
    if (isLocalStorageSupported()) {
      return localStorage.setItem(key, value);
    }
    return cookie.setItem(key, value);
  },
  get: (key) => {
    if (isLocalStorageSupported()) {
      return localStorage.getItem(key);
    }
    return cookie.getItem(key);
  },
  remove: (key) => {
    if (isLocalStorageSupported()) {
      return localStorage.removeItem(key);
    }
    return cookie.removeItem(key);
  },
  isSet: (key) => {
    if (isLocalStorageSupported()) {
      const value = localStorage.getItem(key);
      return value !== null && value !== undefined;
    }
    const value = cookie.getItem(key);
    return (value !== null && value !== undefined);
  }
};




// WEBPACK FOOTER //
// ./src/js/utils/local-storage.js